import * as luxon from 'luxon';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import * as html from 'smg/html';
import Modal from 'smg/modal';
import { CleanNumber } from 'smg/number';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import * as Swiper from 'swiper';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

if (document.body.id === 'usa-coins') {
    main();
}

function main() {
    const $galleryExpand = document.querySelectorAll<HTMLElement>('.gallery-expand');
    for (const $expand of Array.from($galleryExpand)) {
        const $fancybox = $expand.closest('.gallery-item')?.querySelector('[data-fancybox]') as HTMLAnchorElement;
        $expand.addEventListener('click', e => {
            e.preventDefault();
            $fancybox.click();
        });
    }

    new Swiper.Swiper('.swiper', {
        // Optional parameters
        autoplay: true,
        loop: true,

        slidesPerView: 'auto',
        spaceBetween: 8,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });

    const $galleryQuoteTemplate = document.querySelector('#gallery-quote-template') as HTMLTemplateElement;

    const $galleryLinks = document.querySelectorAll<HTMLAnchorElement>('.gallery-link');
    for (const $link of Array.from($galleryLinks)) {
        $link.addEventListener('click', e => {
            e.preventDefault();

            const $img = $link.querySelector('img') as HTMLImageElement;

            const $body = template.Clone($galleryQuoteTemplate).firstElementChild as HTMLElement;

            const $imgParent = $body.querySelector('#modal-img-parent') as HTMLElement;
            $imgParent.innerHTML = `
            <picture>
                <source srcset="${html.Escape($link.getAttribute('data-srcset-webp') ?? '')}" type="image/webp">
                <img src="${html.Escape($link.href)}" class="d-block w-100 h-auto" style="max-width:600px"
                    alt="${html.Escape($img.title)}"
                    title="${html.Escape($img.title)}"
                    data-details="${html.Escape($img.getAttribute('data-details') ?? '')}"
                    srcset="${html.Escape($link.getAttribute('srcset') ?? '')}" width="${$img.width}" height="${$img.height}">
            </picture>`;

            const $type = $body.querySelector('#modal-type') as HTMLSelectElement;
            switch (base(dir($img.src))) {
            case 'simulated-enamel':
                $type.value = 'Made in USA - Simulated Enamel Coin';
                break;
            case 'die-struck':
                $type.value = 'Made in USA - No Color Die Struck';
                break;
            case 'die-struck-with-color':
                $type.value = 'Made in USA - Die Struck with Color';
                break;
            }

            const $name = $body.querySelector('#modal-full-name') as HTMLInputElement;
            const $email = $body.querySelector('#modal-email') as HTMLInputElement;

            const $phone = $body.querySelector('#modal-phone') as HTMLInputElement;
            const p = new phone.Phone($phone);

            const $quantity = $body.querySelector('#modal-quantity') as HTMLInputElement;

            const $dateNeeded = $body.querySelector('#modal-date-needed') as HTMLInputElement;

            const $notes = $body.querySelector('#modal-notes') as HTMLTextAreaElement;

            const $sms = $body.querySelector('#modal-sms') as HTMLInputElement;

            const upload = $body.querySelector('#modal-upload') as HTMLLabelElement;
            let u: uploads.Uploader;
            setTimeout(() => {
                u = new uploads.Uploader(upload, {
                    confirmBtn: m.Element.querySelector('button[type="submit"]') as HTMLButtonElement,
                });
            });

            const m = new Modal({
                // title: $link.dataset.title,
                body: $body,
                preSubmit: () => {
                    $dateNeeded.setCustomValidity('');
                    if ($dateNeeded.value && luxon.DateTime.fromISO($dateNeeded.value) < luxon.DateTime.now()) {
                        $dateNeeded.setCustomValidity('Please enter a date in the future.');
                    }
                },
                onSubmit: () => quoterequests.NewQuoteRequest({
                    company: '',
                    name: $name.value,
                    email: $email.value,
                    phone: p,
                    quantity: parseInt(CleanNumber($quantity.value), 10),
                    sms: $sms.checked,
                    lineItem: 'Challenge Coins',
                    type: $type.value,
                    form: 'usa coins gallery',
                    notes: `I would like something like this coin from your "Custom Coins Made in America" gallery: ${$img.src}\n\n${$notes.value}`,
                    dateNeeded: $dateNeeded.value,
                    uploader: u,
                }).then(async quoteRequest => {
                    const sess = await Session().catch(() => undefined);

                    const dataLayer = ((window.top as myWindow) || window).dataLayer || [];
                    const { firstName, lastName } = GetFirstAndLast(String($name.value));
                    dataLayer.push({
                        'event': 'hugo-usa-coins-quote-request-form-success',
                        'userData': {
                            'email': sess?.email || $email.value,
                            'phone': sess?.phone || await p.Format(),
                            'firstName': sess?.firstName || firstName,
                            'lastName': sess?.lastName || lastName,
                        },
                        'transactionId': quoteRequest.id,
                        'total': quoteRequest.quotes?.[0].cachedTotal,
                    });

                    m.Close();

                    const $body = html.FromString(`<div>
                            <p>
                                We received your quote request! You should hear back from us within one business day.
                            </p>

                            <h3>Here's what you requested:</h3>

                            <ul></ul>

                            </div>`);

                    const $ul = $body.querySelector('ul') as HTMLElement;

                    if (quoteRequest.firstName || quoteRequest.lastName) {
                        $ul.appendChild(html.FromString(`<li><strong>Name:</strong> ${html.Escape(`${quoteRequest.firstName ?? ''} ${quoteRequest.lastName ?? ''}`)}</li>`));
                    }

                    if (quoteRequest.company) {
                        $ul.appendChild(html.FromString(`<li><strong>Company:</strong> ${html.Escape(quoteRequest.company)}</li>`));
                    }

                    if (quoteRequest.email) {
                        $ul.appendChild(html.FromString(`<li><strong>Email:</strong> ${html.Escape(quoteRequest.email)}</li>`));
                    }

                    if (quoteRequest.phone) {
                        $ul.appendChild(html.FromString(`<li><strong>Phone:</strong> ${html.Escape(quoteRequest.phone)}</li>`));
                    }

                    $ul.appendChild(html.FromString('<li><strong>Product:</strong> Challenge Coins</li>'));
                    // get type value from select option text
                    $ul.appendChild(html.FromString(`<li><strong>Type:</strong> ${html.Escape($type.options[$type.selectedIndex].text)}</li>`));

                    if (quoteRequest.quantity) {
                        $ul.appendChild(html.FromString(`<li><strong>Quantity:</strong> ${Intl.NumberFormat().format(quoteRequest.quantity)}</li>`));
                    }

                    if (quoteRequest.dateNeeded) {
                        $ul.appendChild(html.FromString(`<li><strong>Date Needed:</strong> ${html.Escape(luxon.DateTime.fromISO(quoteRequest.dateNeeded).toLocaleString(luxon.DateTime.DATE_FULL))}</li>`));
                    }

                    if ($notes.value) {
                        $ul.appendChild(html.FromString(`<li><strong>Notes:</strong> ${html.Escape($notes.value)}</li>`));
                    }

                    const successModal = new Modal({
                        title: 'Success!',
                        body: $body,
                        cancelText: 'Close',
                        buttons: [{
                            class: 'btn btn-primary',
                            text: 'Request another quote',
                            click: () => {
                                successModal.Close();
                                $link.click();
                            },
                        }],
                    });
                }),
                size: 'modal-xl',
                cancelText: 'Close',
            });

            // const $gallery = document.querySelector('.gallery') as HTMLElement;
            // const $galleryItem = $gallery.querySelector('.gallery-item') as HTMLElement;
            // $galleryItem.innerHTML = `<img src="${$img.src}" alt="${$img.alt}" class="img-fluid">`;
            // $gallery.classList.add('show');

            return false;
        });
    }

    const $galleryButtons = document.querySelectorAll<HTMLButtonElement>('[data-quote-gallery-image]');
    for (const $button of Array.from($galleryButtons)) {
        const img = $button.getAttribute('data-quote-gallery-image');
        if (!img) {
            continue;
        }

        $galleryLinks.forEach($link => {
            if ($link.href.includes(img)) {
                $button.addEventListener('click', e => {
                    e.preventDefault();
                    $link.click();
                });
            }
        });
    }
}

function dir(path: string): string {
    const lastSlashIndex = path.lastIndexOf('/');
    if (lastSlashIndex === -1) {
        return '.'; // No slashes in the path, indicating the current directory
    } else {
        return path.slice(0, lastSlashIndex);
    }
}

function base(path: string): string {
    const lastSlashIndex = path.lastIndexOf('/');
    if (lastSlashIndex === -1) {
        return path; // No slashes in the path, indicating the current directory
    } else {
        return path.slice(lastSlashIndex + 1);
    }
}